<template>
  <el-dialog
    :visible="dialogFormVisible"
    :append-to-body="true"
    @open="open"
    @close="close"
  >
    <h3 slot="title">
      <i class="el-icon-message"></i>
      Support
    </h3>
    <p>Hi there! We're here to help you.</p>
    <p>
      If you have any questions or need assistance, please feel free to
      reach out to us at
      <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>. 
    </p>
    <p>
      For quicker response, please provide as much detail as possible including the video title, your name, and any relevant data to your request.
    </p>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
    </span>

  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      supportEmail: 'storytellers.global@viddsee.com',
    };
  },
  computed: {
    account() {
      const account = this.$store.state.account || {};
      return account.blob || {};
    },
    dialogFormVisible() {
      return this.$store.state.dialogue.support;
    },
  },
  methods: {
    open() {},
    close() {
      this.$store.commit('dialogue/close', 'support');
    },
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/Utilities/Dialogue/SupportNew.vue